module.exports = redis;